import { useTranslation } from "react-i18next";

import { FeedbackContextProvider } from "./feedback_context_provider";
import { ParticipantsOverview } from "./participants_overview";

export const ActivityFeedback = () => {
  const { t } = useTranslation("activities");

  return (
    <FeedbackContextProvider>
      <div role="tabpanel" aria-label={t("show.tabs.feedback")} data-qa-id="ActivityPage.feedbackTab">
        <ParticipantsOverview />
      </div>
    </FeedbackContextProvider>
  );
};
